'use client';

import Link from 'next/link';
import { AnchorHTMLAttributes, ReactNode, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Utils from '@/utils/index';

const DASHBOARD_BASE_URL = process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL || '';

type CtaLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children: ReactNode;
};

const isDashboardUrl = (href: string): boolean => !!DASHBOARD_BASE_URL && href.startsWith(DASHBOARD_BASE_URL);

const CtaLink = ({ href, children, ...rest }: CtaLinkProps) => {
  const pathname = usePathname();
  const [resolvedHref, setResolvedHref] = useState(href);

  useEffect(() => {
    if (!isDashboardUrl(href)) return;
    setResolvedHref(Utils.decorateDashboardUrl(href));
  }, [href, pathname]);

  if (!isDashboardUrl(href)) {
    return (
      <Link href={href} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <a href={resolvedHref} {...rest}>
      {children}
    </a>
  );
};

export default CtaLink;
